export default {"src":"/_next/static/media/containerizedHosting.0e1aa36b.0e1aa36b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};